import type ShariffLinkGeneratorInterface from "@/ts/components/Shariff/Interfaces/ShariffLinkGeneratorInterface";

export default class InstagramShareLinkGenerator implements ShariffLinkGeneratorInterface {
    public generateLink(url: string): string {
        return "https://www.instagram.com/vbshobby/";
    }

    /**
     * Artikel Teilen nicht möglich, es sei denn, er ist mit einem Feed verbunden
     *
     * https://www.instagram.com
     * Startet die Instagram-App.
     *
     * https://www.instagram.com/create/story
     * Startet die Instagram-App mit aktivierter Kamera bzw. Fotobibliothek bei Geräten ohne Kamera.
     *
     * https://www.instagram.com/p/{media_id}
     * Startet die Instagram-App und lädt den Beitrag, der dem angegebenen ID-Wert entspricht (int).
     *
     * https://www.instagram.com/{username}
     * Startet die Instagram-App und lädt den Instagram-Nutzer, der dem angegebenen Benutzernamen-Wert entspricht (string).
     *
     * https://www.instagram.com/explore/locations/{location_id}
     * Startet die Instagram-App und lädt den Standort-Feed, der dem angegebenen ID-Wert entspricht (int).
     *
     * https://www.instagram.com/explore/tags/{tag_name}
     * Startet die Instagram-App und lädt die Seite für den Hashtag, der dem angegebenen Namenswert entspricht (string).
     */




}
